import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { steps } from "../../initiator";

const OnboardingTabsContent = ({
    t, 
    activeTab,
    onNextButtonClicked,
    onBackButtonClicked
}) => {
    const currentStep = steps.find((iTab) => iTab.stepUniqueKey === activeTab)

    if(!currentStep) return null
    return (
        <div className="ai-onboarding-tabs-content">
            <div className={`ai-onboarding-content-item ${activeTab}`}>
                <currentStep.component 
                    onNextButtonClicked={onNextButtonClicked}
                    onBackButtonClicked={onBackButtonClicked}
                />
            </div>
        </div>
    )
}

export default withNamespaces()(
    withRouter(OnboardingTabsContent)
);